// tslint:disable:max-line-length

import React from 'react';

export const OperatorLessThanOrEqual = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M4.32 7.61V6.39l7.41-2.62v1.84L7 7l4.73 1.3v1.83zm0 2.72h7.41V12H4.32z" />
    </svg>
  );
};
